export default {
  'internalError.title': 'Sunucu Hatası',
  'internalError.desc':
    'Hay aksi! Bir şeyler yanlış gitti. İsteğiniz işlenirken beklenmeyen bir hata oluştu. Sorunu en kısa sürede çözeceğiz.',
  'internalError.toHome': 'Kullanıcı Paneline Dön',
};
